<template>
  <div>
    <v-dialog persistent v-model="show" max-width="760">
      <v-card>
        <v-card-title class="headline">Sucursal</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="objetoSucursal.Direccion"
                  autofocus
                  :error-messages="direccionErrors"
                  @input="$v.objetoSucursal.Direccion.$touch()"
                  @blur="$v.objetoSucursal.Direccion.$touch()"
                  dense
                  label="Dirección"
                ></v-text-field>
              </v-col>
              <v-col lg="3" xl="3" cols="12"
                ><v-text-field
                  :error-messages="estadoErrors"
                  @input="$v.objetoSucursal.Estado.$touch()"
                  @blur="$v.objetoSucursal.Estado.$touch()"
                  v-model="objetoSucursal.Estado"
                  dense
                  label="Estado"
                ></v-text-field
              ></v-col>
              <v-col lg="3" xl="3" cols="12"
                ><v-text-field
                  :error-messages="municipioErrors"
                  @input="$v.objetoSucursal.Municipio.$touch()"
                  @blur="$v.objetoSucursal.Municipio.$touch()"
                  v-model="objetoSucursal.Municipio"
                  dense
                  label="Municipio"
                ></v-text-field
              ></v-col>
              <v-col lg="3" xl="3" cols="12"
                ><v-text-field
                v-if="!mostrarComboxColonias"
                  :error-messages="coloniaErrors"
                  @input="$v.objetoSucursal.Colonia.$touch()"
                  @blur="$v.objetoSucursal.Colonia.$touch()"
                  v-model="objetoSucursal.Colonia"
                  dense
                  label="Colonia"
                ></v-text-field>
                <v-combobox
                :error-messages="coloniaErrors"
                  @input="$v.objetoSucursal.Colonia.$touch()"
                  @blur="$v.objetoSucursal.Colonia.$touch()"
                  v-model="objetoSucursal.Colonia"
                  v-if="mostrarComboxColonias"
                  :items="codigosPostalesEncontrados"
                  label="Colonia"
                  outlined
                  dense
                ></v-combobox>
              </v-col>
              <v-col lg="3" xl="3" cols="12"
                ><v-text-field
                  :error-messages="cpErrors"
                  @blur="$v.objetoSucursal.Codigo_Postal.$touch()"
                  v-model="objetoSucursal.Codigo_Postal"
                  dense
                  @input="actualizaCliente()"
                  label="CP"
                ></v-text-field
              ></v-col>
              <v-col lg="6" xl="6" cols="12"
                ><v-text-field
                  :error-messages="telefonoErrors"
                  @input="$v.objetoSucursal.Telefono.$touch()"
                  @blur="$v.objetoSucursal.Telefono.$touch()"
                  v-model="objetoSucursal.Telefono"
                  dense
                  label="Teléfono"
                ></v-text-field
              ></v-col>
              <v-col lg="6" xl="6" cols="12"
                ><v-text-field
                  :error-messages="celularErrors"
                  @input="$v.objetoSucursal.Celular.$touch()"
                  @blur="$v.objetoSucursal.Celular.$touch()"
                  v-model="objetoSucursal.Celular"
                  dense
                  label="Celular"
                ></v-text-field
              ></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrar-modal')" text>Cancelar</v-btn>
          <v-btn color="blue darken-1" @click="insertaSucursal" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loaderSucursales">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';

const estadoRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑ ]{1,40})$/;
const municipioRegex = /^([a-zA-ZÁÉÍÓÚáéíóúñÑ ]{1,80})$/;
const direccionRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){1,50})$/;
const cpRegex = /^([0-9]{3,6})$/;
const coloniaRegex = /^(([a-zA-ZÁÉÍÓÚáéíóúÑñ0-9 !@#$%^&*/|().,´"'_+]||[\n]){0,25})$/;
const telefonoRegex = /^(([0-9]{10})?)$/;
const celularRegex = /^(([0-9]{10})?)$/;

export default {
  validations: {
    objetoSucursal: {
      Estado: {
        required,
        estadoValido(Estado) {
          return estadoRegex.test(Estado);
        },
      },
      Direccion: {
        required,
        direccionValida(Direccion) {
          return direccionRegex.test(Direccion);
        },
      },
      Colonia: {
        required,
        coloniaValida(Colonia) {
          return coloniaRegex.test(Colonia);
        },
      },
      Municipio: {
        required,
        municipioValida(Municipio) {
          return municipioRegex.test(Municipio);
        },
      },
      Telefono: {
        required,
        telefonoValida(Telefono) {
          return telefonoRegex.test(Telefono);
        },
      },
      Celular: {
        celularValida(Celular) {
          return celularRegex.test(Celular);
        },
      },
      Codigo_Postal: {
        required,
        cpValida(Codigo_Postal) {
          return cpRegex.test(Codigo_Postal);
        },
      },
    },
  },
  name: 'ModalNuevaSucursal',
  data: () => ({
    loaderSucursales:false,
    voyAInsertar: true,
    objetoSucursal: {
      Estado: '',
      Direccion: '',
      Colonia: '',
      Municipio: '',
      Telefono: '',
      Celular: '',
      Codigo_Postal: '',
    },
    codigosPostalesEncontrados: [],
    mostrarComboxColonias: false,
  }),
  computed: {
    estadoErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Estado.$dirty) return errors;
      !this.$v.objetoSucursal.Estado.required && errors.push('El campo estado es requerido.');
      !this.$v.objetoSucursal.Estado.estadoValido
        && errors.push('El campo estado no tiene el formato correcto.');
      return errors;
    },
    direccionErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Direccion.$dirty) return errors;
      !this.$v.objetoSucursal.Direccion.required && errors.push('El campo dirección es requerido.');
      !this.$v.objetoSucursal.Direccion.direccionValida
        && errors.push('El campo dirección no tiene el formato correcto.');
      return errors;
    },
    coloniaErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Colonia.$dirty) return errors;
      !this.$v.objetoSucursal.Colonia.required && errors.push('El campo colonia es requerido.');
      !this.$v.objetoSucursal.Colonia.coloniaValida
        && errors.push('El campo colonia no tiene el formato correcto.');
      return errors;
    },
    municipioErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Municipio.$dirty) return errors;
      !this.$v.objetoSucursal.Municipio.required && errors.push('El campo municipio es requerido.');
      !this.$v.objetoSucursal.Municipio.municipioValida
        && errors.push('El campo municipio no tiene el formato correcto.');
      return errors;
    },
    telefonoErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Telefono.$dirty) return errors;
      !this.$v.objetoSucursal.Telefono.required && errors.push('El campo teléfono es requerido.');
      !this.$v.objetoSucursal.Telefono.telefonoValida
        && errors.push('El campo teléfono no tiene el formato correcto.');
      return errors;
    },
    celularErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Celular.$dirty) return errors;
      !this.$v.objetoSucursal.Celular.celularValida
        && errors.push('El campo célular no tiene el formato correcto.');
      return errors;
    },
    cpErrors() {
      const errors = [];
      if (!this.$v.objetoSucursal.Codigo_Postal.$dirty) return errors;
      !this.$v.objetoSucursal.Codigo_Postal.required
        && errors.push('El campo código postal es requerido.');
      !this.$v.objetoSucursal.Codigo_Postal.cpValida
        && errors.push('El campo código postal no tiene el formato correcto.');
      return errors;
    },
  },
  mounted() {
    if (this.sucursalPasada.ID) {
      this.voyAInsertar = false;
      this.objetoSucursal.Codigo_Postal = this.sucursalPasada.CODIGO_POSTAL;
      this.objetoSucursal.Celular = this.sucursalPasada.CELULAR;
      this.objetoSucursal.Estado = this.sucursalPasada.ESTADO;
      this.objetoSucursal.Direccion = this.sucursalPasada.DIRECCION;
      this.objetoSucursal.Colonia = this.sucursalPasada.COLONIA;
      this.objetoSucursal.Municipio = this.sucursalPasada.MUNICIPIO;
      this.objetoSucursal.Telefono = this.sucursalPasada.TELEFONO;
      this.objetoSucursal.Id = this.sucursalPasada.ID;
    } else {
      this.voyAInsertar = true;
    }
  },
  methods: {
    ...mapActions('sucursales', ['insertSucursales', 'editSucursales']),
    ...mapActions('sepomex', ['getDatosConCodigoPostal']),
    async actualizaCliente() {
      this.$v.objetoSucursal.Codigo_Postal.$touch();
      if (this.objetoSucursal.Codigo_Postal.length === 5) {
        this.consultaCodigoPostal(this.objetoSucursal.Codigo_Postal);
      }
    },
    async consultaCodigoPostal(codigo) {
      this.codigosPostalesEncontrados = [];
      const res = await this.getDatosConCodigoPostal(codigo);
      // console.log(res);
      if (res[0] && res[1].length > 0) {
        if (res[1].length > 1) {
          this.mostrarComboxColonias = true;
          res[1].forEach((element) => this.codigosPostalesEncontrados.push(element.ASENTAMIENTO));
        } else {
          this.mostrarComboxColonias = false;
        }
        this.objetoSucursal.Municipio = res[1][0].MUNICIPIO;
        this.objetoSucursal.Colonia = res[1][0].ASENTAMIENTO;
        this.objetoSucursal.Estado = res[1][0].ESTADO;
      }
    },
    async insertaSucursal() {
      console.log(this.objetoSucursal);
      this.$v.$touch();
      if (this.$v.$invalid) {

      } else if (this.voyAInsertar) {
        this.loaderSucursales=true;
        const res = await this.insertSucursales(this.objetoSucursal);
        if (res[0]) {
          this.$emit('muestraDialogExito', 'Sucursal insertada con éxito');
          this.loaderSucursales=false;
        } else {
          this.$emit('muestraModalErrorEnAccion', res[1]);
          this.loaderSucursales=false;
        }
      } else {
        const res = await this.editSucursales(this.objetoSucursal);
        if (res[0]) {
          this.$emit('muestraDialogExito', 'Sucursal editada con éxito');
          this.loaderSucursales=false;
        } else {
          this.$emit('muestraModalErrorEnAccion', res[1]);
          this.loaderSucursales=false;
        }
      }
    },
  },
  props: {
    sucursalPasada: Object,
    show: Boolean,
  },
};
</script>
<style lang="css"></style>
